module.exports = __webpack_public_path__ + "img/s-bombora-logo.81507f51.svg";